import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss']
})
export class FilterButtonComponent {

  @Input() isOpenFilter = false
  @Input() isEnableUpload = true

  @Output() uploadEvent: EventEmitter<void> = new EventEmitter<void>()
  @Output() toggleFilterEvent: EventEmitter<boolean> = new EventEmitter<boolean>()

  uploadFilter() {
    this.uploadEvent.emit()
  }

  toggleFilter() {
    this.isOpenFilter = !this.isOpenFilter
    this.toggleFilterEvent.emit(this.isOpenFilter)
  }
}
